// Mutation hook - dodanie transakcji
// POST /api/ui/sales-crm/deals

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IPostDealRequest } from 'api/types/deals';

interface IPostDealResponse {
  data?: { id?: number };
  message?: string;
  status?: string;
}

const postDeal = (body: IPostDealRequest): Promise<IPostDealResponse> =>
  axios.post(`/sales-crm/deals`, body);

export const usePostDeal = (
  options?: UseMutationOptions<IPostDealResponse, IError, IPostDealRequest>,
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostDealResponse, IError, IPostDealRequest>(postDeal, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(['sales-crm-deals-kanban']);
      await queryClient.invalidateQueries(['sales-crm-deals']);
      options?.onSuccess?.(data, variables, context);
    },
  });
};
